/**
 * 请求类型
 */
export var requestType = {
    Delete: "DELETE",
    Get: "GET",
    Post: "POST",
    Put: "PUT"
};
/**
 * 消息类型
 */
export var reminderType = {
    repayment: {
        name: "还款提醒",
        value: "REPAYMENT",
        code: 69
    },
    followUp: {
        name: "跟进提醒",
        value: "FLLOWUP"
    },
    repaired: {
        value: "REPAIRED",
        name: "修复提醒"
    },
    derate: {
        value: "DERATE",
        name: "减免审批提醒"
    },
    apply: {
        value: "APPLY",
        name: "还款审核提醒"
    },
    assistApprove: {
        value: "ASSIST_APPROVE",
        name: "协催审批提醒"
    },
    visitApprove: {
        value: "VISIT_APPROVE",
        name: "外访申请审批提醒"
    },
    leaveCase: {
        value: "LEAVE_CASE",
        name: "留案案件提醒"
    },
    circulation: {
        value: "CIRCULATION",
        name: "提前流转审批提醒"
    },
    forceTurn: {
        value: "FORCE_TURN",
        name: "强制流转案件提醒"
    },
    memoModify: {
        value: "MEMO_MODIFY",
        name: "修改备注提醒"
    },
    caseExpire: {
        value: "CASE_EXPIRE",
        name: "案件到期提醒"
    },
    verification: {
        value: "VERIFICATION",
        name: "核销审批提醒"
    },
    followUpExport: {
        value: "FOLLOWUP_EXPORT",
        name: "跟进记录导出提醒"
    },
    judicial: {
        value: "JUDICIAL",
        name: "司法审批提醒"
    },
    dowloadFile: {
        value: "DOWNLOAD_FILE",
        name: "文件下载提醒"
    },
    caseImport: {
        value: "CASE_IMPORT",
        name: "案件导入提醒"
    },
    strategy: {
        value: "STRATEGY",
        name: "策略分配提醒"
    }
};
export var dashboardRankType = {
    amount: 0,
    count: 1,
    radio: 2
};
export var dashboardTimeType = {
    year: 0,
    month: 1,
    week: 2
};
export var dashboardQueryType = {
    inner: 1,
    outer: 2
};
/**
 * 颜色标记颜色
 */
export var CaseMarkColor = [
    {
        name: "无色",
        value: "NONE"
    },
    {
        name: "红色",
        value: "RED",
        color: "#F5CBCD"
    },
    {
        name: "蓝色",
        value: "BLUE",
        color: "#C9DDEB"
    },
    {
        name: "绿色",
        value: "GREEN",
        color: "#CDEBD5"
    }
];
/**
 * 案件操作申请类型
 */
export var ApplyType = {
    /**
     * 协催
     */
    assist: {
        name: "协催",
        value: "ASSIT_COLLECTOR"
    },
    /**
     * 协催留案
     */
    assistLeave: {
        name: "协催留案",
        value: "ASSIST_LEAVE_CASE"
    },
    /**
     * 减免
     */
    derate: {
        name: "减免",
        value: "DERATE_CASE"
    },
    /**
     * 暂停催收
     */
    pause: {
        name: "暂停催收",
        value: "PAUSE_CASE"
    },
    /**
     * 委外调账
     */
    adjustment: {
        name: "委外调账",
        value: "ADJUSTMENT_OUT"
    },
    /**
     * 正常留案
     */
    leave: {
        name: "正常留案",
        value: "LEAVE_CASE"
    },
    /**
     * 核销
     */
    verify: {
        name: "核销",
        value: "VERIFY_DESTORY"
    },
    /**
     * 停催激活
     */
    active: {
        name: "停催激活",
        value: "PAUSE_CASE_ACTIVE"
    },
    robbery: {
        name: "抢案共享",
        value: "ROBCASE_SHARE"
    },
    /**
     * 流转
     */
    turn: {
        name: "流转",
        value: "TURN_CASE"
    },
    /**
     * 人工划扣
     */
    repay: {
        name: "人工划扣",
        value: "REPAY_AUTO"
    },
    /**
     * 案件回收
     */
    recycle: {
        name: "案件回收",
        value: "CASE_RECYLE"
    }
};
export var MENU_CHANNEL;
(function (MENU_CHANNEL) {
    /**
     * 不代表任何如口,(公共查询可以使用)
     */
    MENU_CHANNEL[MENU_CHANNEL["NONE"] = -1] = "NONE";
    /**
     * 电催待催收
     */
    MENU_CHANNEL[MENU_CHANNEL["Tel_await"] = 0] = "Tel_await";
    /**
     * 电催个人案件
     */
    MENU_CHANNEL[MENU_CHANNEL["Tel_personal"] = 1] = "Tel_personal";
    /**
     * 电催团队案件
     */
    MENU_CHANNEL[MENU_CHANNEL["Tel_team"] = 2] = "Tel_team";
    /**
     * 电催归C
     */
    MENU_CHANNEL[MENU_CHANNEL["Tel_turn"] = 3] = "Tel_turn";
    /**
     * 电催已结清
     */
    MENU_CHANNEL[MENU_CHANNEL["Tel_settle"] = 4] = "Tel_settle";
    /**
     * 电催回收
     */
    MENU_CHANNEL[MENU_CHANNEL["Tel_recover"] = 5] = "Tel_recover";
    /**
     * 电催停催
     */
    MENU_CHANNEL[MENU_CHANNEL["Tel_closed"] = 6] = "Tel_closed";
    /**
     * 外访待分配
     */
    MENU_CHANNEL[MENU_CHANNEL["Visit_await"] = 7] = "Visit_await";
    /**
     * 外访个人
     */
    MENU_CHANNEL[MENU_CHANNEL["Visit_personal"] = 8] = "Visit_personal";
    /**
     * 外访团队
     */
    MENU_CHANNEL[MENU_CHANNEL["Visit_team"] = 9] = "Visit_team";
    /**
     * 外访归C
     */
    MENU_CHANNEL[MENU_CHANNEL["Visit_turn"] = 10] = "Visit_turn";
    /**
     * 外访结清
     */
    MENU_CHANNEL[MENU_CHANNEL["Visit_settle"] = 11] = "Visit_settle";
    /**
     * 外访回收
     */
    MENU_CHANNEL[MENU_CHANNEL["Visit_recover"] = 12] = "Visit_recover";
    /**
     * 外访停催
     */
    MENU_CHANNEL[MENU_CHANNEL["Visit_closed"] = 13] = "Visit_closed";
    /**
     * 法务待催收
     */
    MENU_CHANNEL[MENU_CHANNEL["Legal_await"] = 14] = "Legal_await";
    /**
     * 法务个人案件
     */
    MENU_CHANNEL[MENU_CHANNEL["Legal_personal"] = 15] = "Legal_personal";
    /**
     * 法务团队案件
     */
    MENU_CHANNEL[MENU_CHANNEL["Legal_team"] = 16] = "Legal_team";
    /**
     * 法务归C
     */
    MENU_CHANNEL[MENU_CHANNEL["Legal_turn"] = 17] = "Legal_turn";
    /**
     * 法务已结清
     */
    MENU_CHANNEL[MENU_CHANNEL["Legal_settle"] = 18] = "Legal_settle";
    /**
     * 法务回收
     */
    MENU_CHANNEL[MENU_CHANNEL["Legal_recover"] = 19] = "Legal_recover";
    /**
     * 法务停催
     */
    MENU_CHANNEL[MENU_CHANNEL["Legal_closed"] = 20] = "Legal_closed";
    /**
     * 外访协催待分配
     */
    MENU_CHANNEL[MENU_CHANNEL["Assist_visit_await"] = 21] = "Assist_visit_await";
    /**
     * 外访协催催收中
     */
    MENU_CHANNEL[MENU_CHANNEL["Assist_visit"] = 22] = "Assist_visit";
    /**
     * 电催协催待分配
     */
    MENU_CHANNEL[MENU_CHANNEL["Assist_tel_await"] = 23] = "Assist_tel_await";
    /**
     * 电催协催催收中
     */
    MENU_CHANNEL[MENU_CHANNEL["Assist_tel"] = 24] = "Assist_tel";
    /**
     * 法务协催催收中
     */
    MENU_CHANNEL[MENU_CHANNEL["Assist_legal"] = 25] = "Assist_legal";
    /**
     * 法务协催待分配
     */
    MENU_CHANNEL[MENU_CHANNEL["Assist_legal_await"] = 26] = "Assist_legal_await";
    /**
     * 法务协催个人催收
     */
    MENU_CHANNEL[MENU_CHANNEL["Assist_legal_personal"] = 27] = "Assist_legal_personal";
    /**
     * 法务协催团队催收
     */
    MENU_CHANNEL[MENU_CHANNEL["Assist_legal_team"] = 28] = "Assist_legal_team";
    /**
     * 诉讼待分配
     */
    MENU_CHANNEL[MENU_CHANNEL["Lawsuit_await"] = 29] = "Lawsuit_await";
    /**
     * 诉讼催收中
     */
    MENU_CHANNEL[MENU_CHANNEL["Lawsuit"] = 30] = "Lawsuit";
    /**
     * 欺诈待分配
     */
    MENU_CHANNEL[MENU_CHANNEL["Fraudulent_await"] = 31] = "Fraudulent_await";
    /**
     * 欺诈催收中
     */
    MENU_CHANNEL[MENU_CHANNEL["Fraudulent"] = 32] = "Fraudulent";
    /**
     * 案件管理-导入中的
     */
    MENU_CHANNEL[MENU_CHANNEL["Case_imported"] = 33] = "Case_imported";
    /**
     * 案件管理-待分配的
     */
    MENU_CHANNEL[MENU_CHANNEL["Case_await"] = 34] = "Case_await";
    /**
     * 案件管理-回收案件池
     */
    MENU_CHANNEL[MENU_CHANNEL["Case_recover"] = 35] = "Case_recover";
    /**
     * 委外待分配
     */
    MENU_CHANNEL[MENU_CHANNEL["Outsource_await"] = 36] = "Outsource_await";
    /**
     * 委外催收中
     */
    MENU_CHANNEL[MENU_CHANNEL["Outsource"] = 37] = "Outsource";
    /**
     * 委外归C
     */
    MENU_CHANNEL[MENU_CHANNEL["Outsource_turn"] = 38] = "Outsource_turn";
    /**
     * 委外结清
     */
    MENU_CHANNEL[MENU_CHANNEL["Outsource_settle"] = 39] = "Outsource_settle";
    /**
     * 委外回收的
     */
    MENU_CHANNEL[MENU_CHANNEL["Outsource_recover"] = 40] = "Outsource_recover";
    /**
     * 委外诉讼待分配
     */
    MENU_CHANNEL[MENU_CHANNEL["Outsource_lawsuit_await"] = 41] = "Outsource_lawsuit_await";
    /**
     * 委外诉讼
     */
    MENU_CHANNEL[MENU_CHANNEL["Outsource_lawsuit"] = 42] = "Outsource_lawsuit";
    /**
     * 委外对账
     */
    MENU_CHANNEL[MENU_CHANNEL["Outsource_checking"] = 43] = "Outsource_checking";
    /**
     * 业务查询-案件查询
     */
    MENU_CHANNEL[MENU_CHANNEL["Query_case_query"] = 44] = "Query_case_query";
    /**
     * 信修案件
     */
    MENU_CHANNEL[MENU_CHANNEL["Letter_repair_case"] = 45] = "Letter_repair_case";
    /**
     * 抢案
     */
    MENU_CHANNEL[MENU_CHANNEL["Case_of_robbery"] = 46] = "Case_of_robbery";
    /**
     * 短信催收
     */
    MENU_CHANNEL[MENU_CHANNEL["Message_collection"] = 47] = "Message_collection";
    /**
     * 车库管理
     */
    MENU_CHANNEL[MENU_CHANNEL["Car_management"] = 48] = "Car_management";
    /**
     * 库存车辆
     */
    MENU_CHANNEL[MENU_CHANNEL["Car_garage"] = 49] = "Car_garage";
    /**
     * 库管审批
     */
    MENU_CHANNEL[MENU_CHANNEL["Car_warehouse_approval"] = 50] = "Car_warehouse_approval";
    /**
     * 案件流转查询
     */
    MENU_CHANNEL[MENU_CHANNEL["Case_return_query"] = 51] = "Case_return_query";
    /**
     * 回款明细报表
     */
    MENU_CHANNEL[MENU_CHANNEL["Repayment_report"] = 52] = "Repayment_report";
    /**
     * 还款确认
     */
    MENU_CHANNEL[MENU_CHANNEL["Repayment_confirmation"] = 53] = "Repayment_confirmation";
    /**
     * 入库车辆报表
     */
    MENU_CHANNEL[MENU_CHANNEL["Warehousing_vehicle_report"] = 54] = "Warehousing_vehicle_report";
    /**
     * 佣金报表
     */
    MENU_CHANNEL[MENU_CHANNEL["Commission_report"] = 55] = "Commission_report";
    /**
     * 绩效报表
     */
    MENU_CHANNEL[MENU_CHANNEL["Performance_report"] = 56] = "Performance_report";
})(MENU_CHANNEL || (MENU_CHANNEL = {}));
/**
 * 当前案件业务类型
 */
export var CASE_CHANNEL = {
    /**
     * 电催
     */
    tel: "TEL",
    /**
     * 外访
     */
    visit: "VISIT",
    /**
     * 法催
     */
    legal: 'LEGAL',
    /**
     * 委外
     */
    OUTER: "OUT",
    /**
     * 核销
     */
    verify: "VERIFY",
    /**
     * 案件导入
     */
    import: "IMPORT",
    /**
     * 协催
     */
    assist: "ASSIST",
    /**
     * 电催协催
     */
    assist_tel: "ASSIST_TEL",
    /**
     * 外访协催
     */
    assist_visit: "ASSIST_VISIT",
    /**
     * 法务协催
     */
    assist_legal: "ASSIST_LEGAL",
    /**
     * 案件导入待分配
     */
    undistributed: "UNDISTRIBUTED",
    /**
     * 信用修复
     */
    CREDIT_REPAIR: "REPAIR",
    /**
     * 诉讼
     */
    law: "LAW",
    /**
     * 欺诈
     */
    fraud: "FRAUD",
    /**
     * 法务
     */
    LEGAL_URGE: "LEGAL_URGE",
    /**
     * 委外电催
     */
    OUTER_TEL: "OUTER_TEL",
    /**
     * 委外外访
     */
    OUTER_VISIT: "OUTER_VISIT",
};
/**
 * 停催类型
 */
export var CASE_HALT_CATEGORY = {
    /**
     * 案件停催
     */
    CASE_HALT: "CASE_HALT",
    /**
     * 电话停催
     */
    TEL_HALT: "TEL_HALT",
    /**
     * 信函停催
     */
    LETTER_HALT: "LETTER_HALT",
    /**
     * 短信停催
     */
    MESSAGE_HALT: "MESSAGE_HALT"
};
/**
 * 案件分配模式
 */
export var DISTRIBUTION_TYPE = [
    { name: "输入数量分配", value: "BY_CUSTOMIZE" },
    { name: "综合分配", value: "BY_INTEGRATE" },
    { name: "按金额平均分配", value: "BY_MONEY" },
    { name: "按数量平均分配", value: "BY_NUMBER" }
];
